import { contactInfo } from '../data/mock';
import { trackContactConversion } from './leads';

const WA_NUMBER = contactInfo.whatsapp.replace(/\D/g, '');

// Specific pre-filled messages for key services (exact-match by service name).
const serviceMessages = {
  'GST Registration': 'Hi BizSarthi Team, I am interested in GST Registration. Please share documents, fees and process.',
  'Private Limited Company': 'Hi BizSarthi Team, I want to register a Private Limited Company. Please guide me with cost, documents and timeline.',
  'LLP Registration': 'Hi BizSarthi Team, I want to register an LLP. Please share cost, documents and process.',
  'Virtual Office for GST': 'Hi BizSarthi Team, I need a Virtual Office for GST Registration. Please share state-wise availability and pricing.',
  'Website Development': 'Hi BizSarthi Team, I want to build a website for my business. Please share pricing and process.',
  'E-commerce Seller Launch': 'Hi BizSarthi Team, I want to start my e-commerce seller business. Please guide me with GST, virtual office, marketplace setup and compliance.',
  'Startup Launch': 'Hi BizSarthi Team, I want to start a new business. Please guide me with registration, GST, website, compliance and startup services.',
};

// Professional pre-filled WhatsApp enquiry message. [service] auto-fills per service.
export function whatsappMessage(service, customMessage = '') {
  if (customMessage && customMessage.trim()) return customMessage.trim();
  const name = service && service.trim() ? service.trim() : '';
  if (serviceMessages[name]) return serviceMessages[name];
  const interestLine = name ? `I am interested in the ${name} service.` : 'I am interested in your services.';
  return (
    `Hello BizSarthi Team,\n\n` +
    `${interestLine}\n\n` +
    `Kindly guide me with the process, documents required, pricing, and timeline.\n\n` +
    `To assist me better, please find the details below:\n\n` +
    `1. Service Required: ${name}\n` +
    `2. City / State:\n` +
    `3. Business Type:\n` +
    `4. Contact Number:\n` +
    `5. Preferred Time to Call:\n\n` +
    `Thank you.`
  );
}

export function whatsappUrl(service, customMessage = '') {
  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(whatsappMessage(service, customMessage))}`;
}

export function openWhatsApp(service, customMessage = '') {
  trackContactConversion('whatsapp', { service: service || 'General enquiry' });
  window.open(whatsappUrl(service, customMessage), '_blank');
}
